import { render, staticRenderFns } from "./ItensREView.vue?vue&type=template&id=20cc182d&scoped=true"
import script from "./ItensREView.vue?vue&type=script&lang=js"
export * from "./ItensREView.vue?vue&type=script&lang=js"
import style0 from "./ItensREView.vue?vue&type=style&index=0&id=20cc182d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cc182d",
  null
  
)

export default component.exports